export default __webpack_public_path__ + "static/media/meal2.e0e5a4a2.svg";